export default __webpack_public_path__ + "static/915-13cb1ab124425db4113c53a25c634dbb.gif";